import React, { useEffect, useState } from "react";
import { getInvoices } from "../../../api/invoiceApi"; 
import { USER_SO_KEY } from "../../../utils/accountUtils"; 
import { Box, CircularProgress } from "@mui/material";
import { DataGridPremium } from "@asf-libs/x-data-grid-premium";
import ProfileHeader from "../../../components/ProfileHeader";
import ProfileBottomNav from "../../../components/ProfileBottomNav";
import { getSessionStorage } from "../../../utils/StorageUtil"; 
import ProfileContext from "../profile/ProfileContext";
import moment from "moment";

// Formatea montos
const formatCurrency = (value, currency) =>
  new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: currency || "ARS",
    minimumFractionDigits: 2,
  }).format(Number(value));

const InvoicesDesktop = () => {
  const user = getSessionStorage(USER_SO_KEY);
  const role = user?.role;
  const idCompanyUser = user?.company?.idCompany;

  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const { status, json } = await getInvoices({ sort: "issueDate,desc" });
        if (status) {
          let filteredInvoices = json;

                    if (role === "RESPONSABLE_FLOTA" && idCompanyUser) {
            filteredInvoices = json.filter((inv) => inv.idCompany === idCompanyUser);
          }

          setInvoices(filteredInvoices);
        }
      } catch (err) {
        console.error("Error fetching invoices", err);
      } finally {
        setLoading(false);
      }
    };

    fetchInvoices();
  }, [role, idCompanyUser]);

  const columns = [
    { field: "numInvoice", headerName: "Comprobante", flex: 1 },
    { field: "detail", headerName: "Detalle", flex: 2 },
    { field: "companyName", headerName: "Cliente", flex: 1 },
    { field: "companyCuit", headerName: "CUIT", flex: 1 },
    {
      field: "numberPlate",
      headerName: "Dominio",
      flex: 1,
      valueGetter: (params) => params.row.unit?.numberPlate || "-",
    },
    {
      field: "issueDate",
      headerName: "Emisión",
      flex: 1,
      valueGetter: (params) => moment(params.row.issueDate).format("DD/MM/YYYY"),
    },
    {
      field: "expirationDate",
      headerName: "Vencimiento",
      flex: 1,
      valueGetter: (params) => moment(params.row.expirationDate).format("DD/MM/YYYY"),
    },
    {
      field: "status",
      headerName: "Estado",
      flex: 1,
      renderCell: (params) => (
        <span style={{ fontWeight: "bold", color: params.value === "Saldada" ? "green" : "red" }}>
          {params.value || "N/A"}
        </span>
      ),
    },
    {
      field: "amount",
      headerName: "Monto",
      flex: 1,
      valueGetter: (params) => formatCurrency(params.row.amount, params.row.currency),
    },
    {
      field: "note",
      headerName: "Nota",
      flex: 2,
      valueGetter: (params) => params.row.note || "",
    },
  ];

  return (
    <ProfileContext.Consumer>
      {() => (
        <Box sx={{ background: "#F2F3F1", mb: "20px" }}>
          <ProfileHeader />
          <Box sx={{ margin: "20px" }}>
            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "70vh" }}>
                <CircularProgress size={80} thickness={4} />
              </Box>
            ) : !invoices.length ? (
              <p>No hay facturas disponibles.</p>
            ) : (
              <Box borderRadius={5} sx={{ background: "#FFFFFF", height: "80vh", pt: 2, pb: 2 }}>
                <h2 style={{ marginLeft: "20px" }}>Facturación</h2>
                <DataGridPremium
                  rows={invoices}
                  columns={columns}
                  getRowId={(row) => row.id}
                  initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
                  pageSizeOptions={[10, 25, 50]}
                  disableRowSelectionOnClick
                  sx={{ margin: "0 20px" }}
                />
              </Box>
            )}
          </Box>
          <ProfileBottomNav goBack={true} />
        </Box>
      )}
    </ProfileContext.Consumer>
  );
};

export default InvoicesDesktop;
